// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M14.0311 1.88843L23.688 11.5453L15.3429 19.8904L15.0735 20.1617H19.9999V22.1617L6.74802 22.1617L0.25293 15.6666L14.0311 1.88843ZM5.78846 12.9595L3.08136 15.6666L7.57645 20.1617H12.2551L12.6215 19.7925L5.78846 12.9595Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-clear-formatting-filled')
export default class ClearFormattingFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'clear-formatting-filled',
    }
  }
}
